import React from "react";
import { useSelector } from "react-redux";
import { selectSpaceBoxActive } from "slices/spaceMediaSlice";
import { APP_COMPONENT } from "components/App";

const AppDropper = () => {
  const spaceBoxActive = useSelector(selectSpaceBoxActive);
  if (spaceBoxActive) {
    let elem = document.getElementById(APP_COMPONENT);
    if (elem) elem.classList.add("pinned-active");
  } else {
    let elem = document.getElementById(APP_COMPONENT);
    if (elem) elem.classList.remove("pinned-active");
  }
  return <></>;
};

export default AppDropper;
